import { Link } from 'gatsby'
import { toFriendlyKitId } from 'helpers/string'
import { UnmatchedResults_unmatchedResultsConnection_edges_node_statedKit } from './__generated__/UnmatchedResults'

interface KitLinkProps {
  kit: UnmatchedResults_unmatchedResultsConnection_edges_node_statedKit
}

const KitLink = ({ kit }: KitLinkProps) => {
  return (
    <Link to={`/dashboard/kit/${kit.id}`}>
      {toFriendlyKitId(kit.id)} ({kit.sku}, {kit.status})
    </Link>
  )
}

export default KitLink
